import React, { useCallback, useEffect, useState } from "react"
import { OutlinedInput, InputAdornment, FormControl, TableContainer, Pagination, PaginationItem, Badge } from "@mui/material";
import OrderDetailsDailog from "./OrderDetails";
import ClearIcon from "@mui/icons-material/Clear";
import { Backdrop, Button, Paper, Grid, CircularProgress, Link, IconButton, Table, TableBody, TableCell, TableHead, TableRow, ThemeProvider, createTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ServiceApi } from "../../services/index.service";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";

export const OrderManagement = () => {
    const pageInitialParams = {
        search: "",
        page: 1,
        size: 15
    }
    const { enqueueSnackbar } = useSnackbar();
    const serviceapi = new ServiceApi();
    const { storage } = useSelector((state) => state);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [orderDetails, setOrderDetails] = useState({
        show: false,
        details: null
    });
    const [ordersList, setOrdersList] = useState([]);
    const [params, setParams] = useState(pageInitialParams);
    const [totalItems, setTotalItems] = useState('');
    const [statusList, setStatusList] = useState([]);

    useEffect(() => {
        if (storage?.store?.intStoreID)
            getOrdersList(params);
    }, [params]);

    useEffect(() => {
        if (storage?.store?.intStoreID) {
            setQuery("");
            setParams(pageInitialParams);
        }
    }, [storage?.store?.intStoreID]);

    const getOrdersList = async (params) => {
        try {
            setLoading(true);
            const response = await serviceapi.getCateringOrders(
                storage?.store?.intStoreID, params
            );
            // console.log('response ', response);
            setOrdersList(response.data?.items);
            setTotalItems(response.data?.total_items);
            setStatusList(response.data?.order_status);
        } catch (e) {
            enqueueSnackbar("Failed to fetch Catering Orders", {
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "error",
            });
        }
        finally {
            setLoading(false);
        }
    };

    const handlePageChange = (event, value) => {
        setParams({ ...params, page: value });
    };

    const handleManageOrderSearch = (event) => {
        if (event.target.value !== "") {
            setQuery(event.target.value);
            searchDelay(params, event.target.value);
        } else {
            setQuery("");
            setParams({ ...params, search: '', page: pageInitialParams?.page, size: pageInitialParams?.size });
        }
    };

    const clearFilters = () => {
        setQuery("");
        setParams({ ...params, search: '', page: pageInitialParams?.page, size: pageInitialParams?.size });
    };

    const searchDelay = useCallback(
        debounce((params, val) => {
            setParams({ ...params, search: val, page: pageInitialParams?.page, size: pageInitialParams?.size });
        }, 500),
        []
    );

    function debounce(fn, delay) {
        let timer;
        return function () {
            let context = this,
                args = arguments;
            clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(context, args);
            }, delay);
        };
    }
    const displayViewDetails = (order) => {
        setOrderDetails({ show: true, details: { ...order } });
    }

    const closeViewDetailsDialog = () => {
        setOrderDetails({ show: false, details: null });
    }

    const handleStatusUpdate = async (status) => {
        try {
            setLoading(true);
            const response = await serviceapi.updateOrderStatus({
                intStoreID: storage?.store?.intStoreID,
                intOrderID: orderDetails?.details?.intOrderID,
                vchStatus: status,
            });
            closeViewDetailsDialog();
            await getOrdersList(params);
            enqueueSnackbar(response.data?.message || "Orders Status updated successfully. ", {
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "success",
            });
        } catch (e) {
            enqueueSnackbar(e?.response?.data?.message || "Failed to update Orders Status", {
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "error",
            });
            setLoading(false);
        }
    }

    const NewStatus = styled(Badge)(({ theme }) => ({
        padding: '4px 14px',
        backgroundColor: '#D9E9E1 !important',
        borderRadius: '100px',
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#006838',
        boxShadow: "none",

    }));

    const PendingStatus = styled(Paper)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '4px 14px',
        backgroundColor: '#F2D9D9 !important',
        borderRadius: '100px',
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#A50000',
        boxShadow: "none",
        border: "1px solid #cccccc59",
    }));

    return (
        <div className="mx-auto mt-3 sm:px-6 lg:px-4 py-4 bg-white shadow-none rounded-lg border border-gray-300">
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className="rounded-md bg-white">
                <div className="sm:flex sm:items-center sm:justify-between">
                    <div className="flex items-center gap-2">
                        <FormControl sx={{ minWidth: 150 }}>
                            <OutlinedInput
                                autoComplete="off"
                                style={{
                                    fontFamily:
                                        "Roboto, 'Open Sans', Verdana, sans-serif, FontAwesome",
                                }}
                                className="bg-white text-xs border rounded border-gray-200"
                                sx={{
                                    height: 40,
                                    paddingRight: 0,
                                    width: 215,
                                }}
                                id="outlined-controlled"
                                placeholder="&#xF002; search"
                                name="mGuestSearch"
                                value={query}
                                onChange={handleManageOrderSearch}
                                inputProps={{
                                    style: {
                                        color: "#000",
                                        fontSize: "15px",
                                    },
                                }}
                                endAdornment={
                                    <InputAdornment>
                                        <IconButton
                                            onClick={clearFilters}
                                            sx={{
                                                visibility: query ? "visible" : "hidden",
                                            }}
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <Paper className="mt-3 shadow-none">
                <TableContainer sx={{ maxHeight: 'calc(100vh - 333px)', borderBottom: '2px solid #e2e2e2' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" className="bg-[#484848] text-white py-2">Customer Name</TableCell>
                                <TableCell className="bg-[#484848] text-white border-[1px] py-2">Phone Number</TableCell>
                                <TableCell className="bg-[#484848] text-white border-[1px] py-2">Event Date</TableCell>
                                <TableCell className="bg-[#484848] text-white border-[1px] py-2">Date Received</TableCell>
                                <TableCell className="bg-[#484848] text-white border-[1px] py-2">Event Type</TableCell>
                                <TableCell className="bg-[#484848] text-white border-[1px] py-2">No of Guests</TableCell>
                                <TableCell align="center" className="bg-[#484848] text-white border-[1px] py-2">Status</TableCell>
                                <TableCell align="center" className="bg-[#484848] text-white border-[1px] py-2">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {ordersList.map((order, index) =>
                                <TableRow
                                    key={index}
                                    sx={{
                                        '&:nth-of-type(odd)': { backgroundColor: '#FFF' },
                                        '&:nth-of-type(even)': { backgroundColor: '#FFF8F8' },
                                        // backgroundColor: expandedRow === i && '#F3FFF4 !important'
                                    }}
                                >
                                    <TableCell align="center" className="border-[1px] py-1.5">{order.vchGuestName}</TableCell>
                                    <TableCell align="left" className="border-[1px] py-1.5">{order.vchPhone}</TableCell>
                                    <TableCell align="left" className="border-[1px] py-1.5">{order.dteEventDate}</TableCell>
                                    <TableCell align="left" className="border-[1px] py-1.5">{order.dteDateReceived}</TableCell>
                                    <TableCell align="left" className="border-[1px] py-1.5">{order.vchEventType}</TableCell>
                                    <TableCell align="left" className="border-[1px] py-1.5">{order.intTotalGuests}</TableCell>
                                    <TableCell align="center" className="border-[1px] py-1.5">
                                        <Badge badgeContent={order.vchStatus} classes={{ badge: 'py-3 px-3 rounded-full bg-[#0098061f] text-[#009806]' }} />
                                        {/* {order.vchStatus === 'Pending Following' && (<PendingStatus>
                                            {order.vchStatus}
                                        </PendingStatus>)}
                                        {order.vchStatus === 'Delivered' && (<NewStatus>
                                            {order.vchStatus}
                                        </NewStatus>)}
                                        {order.vchStatus === 'Revised' && (<NewStatus>
                                            {order.vchStatus}
                                        </NewStatus>)}
                                        {order.vchStatus === 'Cancelled' && (<NewStatus>
                                            {order.vchStatus}
                                        </NewStatus>)}
                                        {order.vchStatus === 'Completed' && (<NewStatus>
                                            {order.vchStatus}
                                        </NewStatus>)} */}
                                    </TableCell>
                                    <TableCell align="center" className="border-[1px] py-1.5">
                                        <IconButton onClick={() => displayViewDetails(order)}>
                                            <img width={24} height={24} src={'../../assets/icons/document-view.png'} alt="view-details" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', background: '#fff', border: '1px solid #e2e2e2' }}>
                    <Pagination showFirstButton showLastButton
                        count={Math.ceil(totalItems / params.size)}
                        page={params.page}
                        onChange={handlePageChange}
                        renderItem={(item) => (
                            <PaginationItem
                                sx={{
                                    "&.Mui-selected": {
                                        color: '#fff',
                                        backgroundColor: "#C12637"
                                    },
                                }}
                                component="a"
                                {...item}
                            />
                        )}
                    />
                </div>
            </Paper>
            {orderDetails?.show && <OrderDetailsDailog details={orderDetails?.details} statusList={statusList} closeViewDetailsDialog={closeViewDetailsDialog} handleStatusUpdate={handleStatusUpdate} />}
        </div >
    )
}